import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import './Auth.css';


import { API } from '../config';

export default function Register() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'member'
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/register`, formData);
      
      if (formData.role === 'leadership') {
        toast.success('Registration successful! Your leadership account will be reviewed by an administrator.');
      } else {
        toast.success('Registration successful! You can now login.');
      }
      
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" data-testid="register-page">
      <div className="auth-container">
        <div className="auth-card card">
          <div className="auth-header">
            <h1>Create Account</h1>
            <p>Join your group management platform</p>
          </div>

          <div className="info-box">
            <p><strong>Members:</strong> If you're a group member, you should use the <Link to="/member-signup" style={{color: '#1E40AF', fontWeight: 'bold'}}>member registration</Link> page instead.</p>
          </div>

          <form onSubmit={handleSubmit} data-testid="register-form">
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                data-testid="name-input"
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                data-testid="email-input"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                minLength="6"
                data-testid="password-input"
              />
            </div>

            <div className="form-group">
              <label>Account Type</label>
              <select
                value={formData.role}
                onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                data-testid="role-select"
              >
                <option value="member">Member</option>
                <option value="leadership">Leadership</option>
              </select>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary full-width" 
              disabled={loading}
              data-testid="register-submit-btn"
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          <div className="auth-footer">
            Already have an account? <Link to="/login">Login here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}